/**
 * Created by anatoly on 01.04.2026
 */

const LeaguesUpgradeAction = function (f) {
    if (cleverapps.leagues && cleverapps.leagues.wantsLeaguesUpgradeWindow) {
        cleverapps.leagues.onChangeLeague(f);
    } else {
        f();
    }
};
